module.exports = __webpack_public_path__ + "img/repello_para_interiores_y_exteriores.53527a14.png";